<template>
   <v-container fluid style="padding-bottom: 0;">
        <v-layout column wrap>
            <v-flex grow>
              <v-layout row fill-height wrap>
                    <v-flex>
                    <v-card style="height: 100%;">
                       <v-card-title>
                            <v-layout row style="margin: 0;" align-center justify-space-between>
                                <v-flex shrink>
                                    <h2 style="font-size: 1.5em; display: inline-block;">Superadmins</h2>
                                </v-flex>
                            </v-layout>
                       </v-card-title>
                       <datatable
                            :items="superAdmins"
                            :headers="superAdminsHeaders"
                            :pagination.sync="pagination"
                            :no-data-text="'Es wurden noch keine SuperAdmins hinzugefügt'"
                        >
                            <template v-slot:items="props">
                                <td>
                                    <template v-if="props.item.firstname">
                                        {{props.item.firstname}}
                                    </template>
                                    <template v-else>
                                        -
                                    </template>
                                </td>
                                <td>
                                    <template v-if="props.item.lastname">
                                        {{props.item.lastname}}
                                    </template>
                                    <template v-else>
                                        -
                                    </template>
                                </td>
                                <td>
                                    <v-layout row>
                                        <v-flex grow>{{props.item.email}}</v-flex>
                                        <v-flex shrink>
                                            <span v-if="!props.item.isActivated" style="background-color: orange; border-radius: 4px; padding: 0 4px; white-space: nowrap;">nicht aktiviert</span>
                                        </v-flex>
                                        <v-flex shrink v-if="props.item.emailFailure == 1" >
                                            <v-tooltip bottom>
                                                <template v-slot:activator="{ on }">
                                                    <v-btn small class="error--text" icon v-on="on">
                                                        <v-icon small>warning</v-icon>
                                                    </v-btn>
                                                </template>
                                                <span>Die E-Mail-Adresse ist ungültig.</span>
                                            </v-tooltip>
                                        </v-flex>
                                    </v-layout>
                                </td>
                                <td>
                                  <v-btn 
                                    :disabled="props.item.userId === user.userId"
                                    @click="removeSuperAdminRole(props.item.userId)"
                                  >
                                    SUPERADMIN-ROLLE entfernen
                                  </v-btn>
                                </td>  
                            </template>
                        </datatable>
                        <v-layout row style="padding: 0 16px;">
                          <v-flex 
                            :shrink="$vuetify.breakpoint.smAndUp"
                            :grow="$vuetify.breakpoint.xs"
                          >
                            <v-select
                              :items="allDSBs"
                              v-model="currentDSB"
                              item-text="email"
                              return-object
                              label="DSBs"
                            >
                            </v-select>
                          </v-flex>
                            <v-flex shrink>
                              <v-btn
                                @click="addDSBasSuperAdmin()"
                              >
                                SuperAdmin-Rolle hinzufügen
                              </v-btn>
                            </v-flex>
                        </v-layout>
                    </v-card>
                    </v-flex>
              </v-layout>
            </v-flex>
        </v-layout>
   </v-container>
</template>

<script>
import DatatableVue from './Datatable.vue'

export default {
  name: 'DatatableSuperAdmins',

  components: {
    "datatable": DatatableVue
  },

  data: () => ({
    superAdmins: [],
    superAdminsHeaders: [
      { text: 'Vorname', value: 'firstname' },
      { text: 'Nachname', value: 'lastname' },
      { text: 'E-Mail', value: 'email' },
      { text: '', value: 'name', sortable: false }
    ],

    allDSBs: [],
    currentDSB: null,

    allUsers: [],
    allUserHeaders: [
      {text: 'Vorname', value: 'firstname'},
      {text: 'Nachname', value: 'lastname'},
      {text: 'E-Mail', value: 'email'},
      {text: '', value: 'button'}
    ],
    pagination: {sortBy: 'email'},


    superAdminEdit: null,
  }),

  computed: {
    user() {
      return this.$store.state.user;
    }
  },

  mounted() {
    this.init();
  },

  methods: {
    init() {
      this.refreshSuperAdmins();
      this.refreshDSBs();
    },

    async refreshSuperAdmins() {
      const admins = await this.fetchSuperAdmins();
      this.setSuperAdmins(admins);
    },

    async refreshDSBs() {
      const dsbs = await this.fetchAllDSBs();
      this.setAllDSBs(dsbs);
    },

    fetchAllDSBs() {
      return new Promise((resolve) => {
        this.axios.axiosCall({
            url: actionUrl + "rest/monitor/dsbs",
            method: 'get',
            success: function(response) {
                resolve(response.data)
            }
        })
      })
    },

    setAllDSBs(dsbs) {
      this.allDSBs = [];
      for(let dsb of dsbs){
        this.allDSBs.push(dsb);
      }
      if(this.currentDSB === null) {
        this.currentDSB = this.allDSBs[0];
      }
    },

    async addDSBasSuperAdmin() {
      await this.updateDSBasSuperAdmin();
      this.currentDSB = null;
      this.init();
    },


    async removeSuperAdminRole(userId) {
      await this.deleteSuperAdminRole(userId);
      this.init();
    },

    deleteSuperAdminRole(userId) {
      return new Promise((resolve) => {
        this.axios.axiosCall({
            url: actionUrl + `rest/monitor/superAdmin/${userId}`,
            method: 'delete',
            success: function(response) {
                resolve(response.data)
            }
        })
      })
    },

    updateDSBasSuperAdmin() {
      return new Promise((resolve) => {
        const userId = this.currentDSB.userId;
        this.axios.axiosCall({
            url: actionUrl + `rest/monitor/superAdmin/${userId}`,
            method: 'put',
            success: function(response) {
                resolve(response.data)
            }
        })
      })
    },

    fetchSuperAdmins() {
      return new Promise((resolve) => {
        this.axios.axiosCall({
            url: actionUrl + "rest/monitor/superAdmins",
            method: 'get',
            success: function(response) {
                resolve(response.data)
            }
        })
      })
    },

    setSuperAdmins(superAdmins) {
      this.superAdmins = [];
      for(let superAdmin of superAdmins){
        this.superAdmins.push(superAdmin);
      }
    },

    fetchAllUsers() {
      return new Promise((resolve) => {
        this.axios.axiosCall({
            url: actionUrl + "rest/monitor/allUsers",
            method: 'get',
            success: function(response) {
                resolve(response.data)
            }
        })
      })
    },

    setAllUsers(allUsers) {
      this.allUsers = [];
      for(let user of allUsers){
        this.allUsers.push(user);
      }
    },
  },
}
</script>

<style>

</style>